import { render, staticRenderFns } from "./NotificacionBalance.vue?vue&type=template&id=6dcd746c"
import script from "./NotificacionBalance.vue?vue&type=script&lang=ts"
export * from "./NotificacionBalance.vue?vue&type=script&lang=ts"
import style0 from "./NotificacionBalance.vue?vue&type=style&index=0&id=6dcd746c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports